import '../CSS/FEMAReportToast.css';

const FEMAReportToast = ({ show, type, blobUrl, filename, progress, onDismiss }) => {
  if (!show) return null;

  return (
    <div className={`fema-toast fema-toast--${type}`}>
      <div className="fema-toast__body">
        {type === 'progress' && progress && (
          <>
            <p className="mb-1 fw-semibold">
              Downloading report {progress.current} of {progress.total}...
            </p>
            {progress.failed > 0 && (
              <small className="text-danger">{progress.failed} failed</small>
            )}
            <div className="progress mt-1" style={{ height: '6px' }}>
              <div
                className="progress-bar"
                role="progressbar"
                style={{ width: `${(progress.current / progress.total) * 100}%` }}
                aria-valuenow={progress.current}
                aria-valuemin="0"
                aria-valuemax={progress.total}
              />
            </div>
          </>
        )}
        {type === 'success' && (
          <>
            <p className="mb-1">
              {progress && progress.total > 1
                ? `${progress.total - progress.failed} of ${progress.total} reports downloaded successfully.`
                : 'Your FEMA report is ready, downloading now...'}
            </p>
            {blobUrl && (
              <a href={blobUrl} download={filename}>
                Download manually
              </a>
            )}
            {progress && progress.failed > 0 && (
              <small className="text-danger d-block mt-1">
                {progress.failed} report{progress.failed !== 1 ? 's' : ''} failed to download.
              </small>
            )}
          </>
        )}
        {type === 'error' && (
          <p className="mb-0">Failed to generate FEMA report. Please try again.</p>
        )}
      </div>

      <button
        className="fema-toast__dismiss"
        onClick={onDismiss}
        aria-label="Dismiss notification"
      >
        &times;
      </button>
    </div>
  );
};

export default FEMAReportToast;
